import * as yup from 'yup';
import { CommonHelper } from '../utils/helpers/CommonHelper';
import { DefaultCountry } from '../utils/constants/CountryConstant';
import { FREE_TRIAL_PLAN_ID } from '../utils/helpers/SubscriptionPlanHelper';

export enum SubscriptionPlanStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
  PENDING = 'pending',
}

export enum PaymentStatus {
  VERIFIED = 'verified',
  AWAITING_VERIFICATION = 'awaiting_verify',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected',
}

export enum SubscriptionPlanEnum {
  FREE_TRIAL = 'FREE_TRIAL',
  FREE = 'FREE',
  GOLD = 'GOLD',
  SILVER = 'SILVER',
  PREMIUM = 'PREMIUM',
  PREMIUM_PRO = 'PREMIUM_PRO',
  DIAMOND = 'DIAMOND',
  PLATINUM = 'PLATINUM',
}

export enum SubscriptionAction {
  FREE_TRAIL = 'free_trail',
  BUY = 'buy',
  UPGRADE = 'upgrade',
}

export enum ResponseHistoryAction {
  DOCUMENT_REQUEST = 'document_request',
  DOCUMENT_REQUEST_CANCELED = 'document_request_canceled',
  DOCUMENT_REQUEST_UPDATED = 'document_request_updated',
  RESUBMIT_DOCUMENT = 'resubmit_document',
}

export enum SubscriptionDocumentType {
  PAY_SLIP = 'pay_slip',
  TAX_DOCUMENT = 'tax_document',
}

export enum PriceMovingAverageTabShow {
  PERFORMANCE = 'PERFORMANCE',
  COMMODITY = 'COMMODITY',
}

export enum CommodityItemStatus {
  ACTIVE = 'active',
  DISABLE = 'disable',
  NONE = '',
}

export interface CommodityItemDefault {
  id: number;
  name: string;
  color: string;
  disable: boolean;
  displayTitle: boolean;
  tooltipPlacement: string;
  nonePointer: boolean;
}

export interface CompanySubscriptionPlan {
  supplierSubscriptionID?: number;
  subscriptionPlanID?: number;
  title?: string;
  startDate?: number;
  endDate?: number;
  subscriptionStatus?: SubscriptionPlanStatus;
  paymentStatus?: PaymentStatus;
  availableQuote?: number;
  maxJobValue?: number;
  productShowCase?: number;
  userAccount?: number;
  analysisReport?: boolean;
  profileListing?: boolean;
  trialed?: boolean;
  documentRequest?: {
    documentRequire: string[];
    detail?: string;
  };
}

// export interface PostFreeTrialPlanSchema {
//   subscriptionPlanID: number;
//   firstName: string;
//   lastName: string;
//   email: string;
//   phone: string;
//   transferDate?: string;
//   transferTime?: string;
//   bank?: string;
//   amount?: number;
//   currency?: string;
//   businessType: string;
// }

// export interface PostPricePlanSchema {
//   subscriptionPlanID: number;
//   firstName: string;
//   lastName: string;
//   email: string;
//   phone: string;
//   transferDate: string;
//   transferTime: string;
//   bank: string;
//   amount: number;
//   currency: string;
//   businessType: string;
// }

export interface PostFreeTrialPlanSchema {
  subscriptionPlanID: number;
  personalDetailStep: PersonalDetailSchema;
  uploadConsentStep: UploadConsentSchema;
  // paymentMethodStep: PaymentMethodFreeSchema;
}

export interface PostPricePlanSchema {
  subscriptionPlanID: number;
  personalDetailStep: PersonalDetailSchema;
  uploadConsentStep: UploadConsentSchema;
  paymentMethodStep: PaymentMethodSchema;
}

export interface PersonalDetailSchema {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export interface UploadConsentSchema {
  businessType: string;
}

export interface PaymentMethodSchema {
  transferDate: string;
  transferTime: string;
  bank: string;
  amount: number;
  currency: string;
}

// export interface PaymentMethodFreeSchema {
//   transferDate?: string;
//   transferTime?: string;
//   bank?: string;
//   amount?: number;
//   currency?: string;
// }

export interface DocumentSchema {
  uuid: string;
  originalName: string;
  fileExtension: string;
  uploadDate: Date;
}

// export const postFreeTrialPlanSchema: yup.SchemaOf<PostFreeTrialPlanSchema> = yup
//   .object({
//     subscriptionPlanID: yup.number().default(FREE_TRIAL_PLAN_ID),
//     firstName: yup.string().required('กรุณาระบุชื่อ'),
//     lastName: yup.string().required('กรุณาระบุนามสกุล'),
//     email: yup.string().required('กรุณากรอกอีเมล').email('กรุณากรอกอีเมลในรูปแบบที่ถูกต้อง'),
//     phone: yup
//       .string()
//       .required('กรุณาระบุเบอร์โทรศัพท์')
//       .test({
//         name: 'is phone valid',
//         test: function (value) {
//           if (value) {
//             const code = value.substring(0, 3);
//             let errMsg =
//               code === DefaultCountry.countryCallingCode
//                 ? 'เบอร์โทรศัพท์ประเทศไทยต้องมีตัวเลข 8 หรือ 9 หลักเท่านั้น'
//                 : 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้องตามรหัสประเทศที่คุณเลือก';
//             const err = this.createError({ message: errMsg });
//             try {
//               if (!CommonHelper.isValidPhoneNumber(value)) {
//                 return err;
//               }
//             } catch {
//               return err;
//             }
//           }
//           return true;
//         },
//       }),
//     transferDate: yup.string(),
//     transferTime: yup.string(),
//     bank: yup.string(),
//     amount: yup.number(),
//     currency: yup.string(),
//     businessType: yup.string().required('SubscriptionPayment.Error.BusinessType'),
//   })
//   .defined();

// export const postPricePlanSchema: yup.SchemaOf<PostPricePlanSchema> = yup
//   .object({
//     firstName: yup.string().required('SubscriptionPayment.Error.FirstNameRequired'),
//     lastName: yup.string().required('SubscriptionPayment.Error.LastNameRequired'),
//     email: yup.string().required('SubscriptionPayment.Error.EmailRequired'),
//     phone: yup
//       .string()
//       .required('SubscriptionPayment.Error.PhoneRequired')
//       .test({
//         name: 'is phone valid',
//         test: function (value) {
//           if (value) {
//             const code = value.substring(0, 3);
//             let errMsg =
//               code === DefaultCountry.countryCallingCode
//                 ? 'SubscriptionPayment.Error.ThaiPhoneInvalid'
//                 : 'SubscriptionPayment.Error.PhoneInvalid';
//             const err = this.createError({ message: errMsg });
//             try {
//               if (!CommonHelper.isValidPhoneNumber(value)) {
//                 return err;
//               }
//             } catch {
//               return err;
//             }
//           }
//           return true;
//         },
//       }),
//     subscriptionPlanID: yup.number().required(),
//     transferDate: yup.string().required('SubscriptionPayment.Error.TransferDateRequired'),
//     transferTime: yup.string().required('SubscriptionPayment.Error.TransferTimeRequired'),
//     bank: yup.string().required('SubscriptionPayment.Error.TransferFromRequired'),
//     amount: yup.number().required('SubscriptionPayment.Error.AmountRequired'),
//     currency: yup.string().required(),
//     businessType: yup.string().required('SubscriptionPayment.Error.BusinessType'),
//   })
//   .defined();

export const personalDetailSchema: yup.SchemaOf<PersonalDetailSchema> = yup
  .object({
    firstName: yup.string().required('SubscriptionPayment.Error.FirstNameRequired'),
    lastName: yup.string().required('SubscriptionPayment.Error.LastNameRequired'),
    email: yup
      .string()
      .required('SubscriptionPayment.Error.EmailRequired')
      .email('SubscriptionPayment.Error.EmailInvalid'),
    phone: yup
      .string()
      .required('SubscriptionPayment.Error.PhoneRequired')
      .test({
        name: 'is phone valid',
        test: function (value) {
          if (value) {
            const code = value.substring(0, 3);
            let errMsg =
              code === DefaultCountry.countryCallingCode
                ? 'SubscriptionPayment.Error.ThaiPhoneInvalid'
                : 'SubscriptionPayment.Error.PhoneInvalid';
            const err = this.createError({ message: errMsg });
            try {
              if (!CommonHelper.isValidPhoneNumber(value)) {
                return err;
              }
            } catch {
              return err;
            }
          }
          return true;
        },
      }),
  })
  .defined();

export const uploadConsentSchema: yup.SchemaOf<UploadConsentSchema> = yup
  .object({
    businessType: yup.string().required('SubscriptionPayment.Error.BusinessType'),
  })
  .defined();

export const paymentMethodSchema: yup.SchemaOf<PaymentMethodSchema> = yup
  .object({
    transferDate: yup.string().required('SubscriptionPayment.Error.TransferDateRequired'),
    transferTime: yup.string().required('SubscriptionPayment.Error.TransferTimeRequired'),
    bank: yup.string().required('SubscriptionPayment.Error.TransferFromRequired'),
    amount: yup.number().required('SubscriptionPayment.Error.AmountRequired'),
    currency: yup.string().required(),
  })
  .defined();

// export const paymentMethodFreeSchema: yup.SchemaOf<PaymentMethodFreeSchema> = yup
//   .object({
//     transferDate: yup.string(),
//     transferTime: yup.string(),
//     bank: yup.string(),
//     amount: yup.number(),
//     currency: yup.string(),
//   })
//   .defined();

export const postFreeTrialPlanSchema: yup.SchemaOf<PostFreeTrialPlanSchema> = yup
  .object({
    subscriptionPlanID: yup.number().default(FREE_TRIAL_PLAN_ID),
    personalDetailStep: personalDetailSchema,
    uploadConsentStep: uploadConsentSchema,
    // paymentMethodStep: paymentMethodSchema,
  })
  .defined();

export const postPricePlanSchema: yup.SchemaOf<PostPricePlanSchema> = yup
  .object({
    subscriptionPlanID: yup.number().required(),
    personalDetailStep: personalDetailSchema,
    uploadConsentStep: uploadConsentSchema,
    paymentMethodStep: paymentMethodSchema,
  })
  .defined();
